import React, { useState, useEffect } from "react";
import { FaAngleDoubleRight } from "react-icons/fa";

const Tab = () => {
  const [data, setData] = useState(null);
  const [activeCompany, setActiveCompany] = useState("");
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    fetch("https://course-api.com/react-tabs-project")
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setActiveCompany(data[0].company);
        setIsActive(data[0]);
      })
      .catch((error) => console.log(error));
  }, []);

  if (!data) {
    return <p>Loading...</p>;
  }

  function handleClick(company) {
    setActiveCompany(company);
  }

  const filteredData = data.filter((datum) => datum.company === activeCompany);

  return (
    <section className="section">
      <div className="title">
        <h2>Experience</h2>
        <div className="underline"></div>
      </div>

      <div className="jobs-center">
        <div className="btn-container">
          {data.map((item) => {
            const { id, company } = item;
            return (
              <button
                key={id}
                className={`job-btn ${
                  company === activeCompany ? "active-btn" : "false"
                }`}
                onClick={() => handleClick(company)}
              >
                {company}
              </button>
            );
          })}
        </div>

        {filteredData.map((item) => {
          const { order, title, dates, duties, company } = item;
          return (
            <article
              key={item.id}
              className={`job-info ${
                isActive === item || company === activeCompany ? "active" : ""
              }`}
            >
              <h3>{title}</h3>
              <h4>{company}</h4>
              <p className="job-date">{dates}</p>

              {duties.map((duty) => {
                return (
                  <>
                    <div className="job-desc">
                      <FaAngleDoubleRight />
                      <p key={duty}>{duty}</p>
                    </div>
                  </>
                );
              })}
            </article>
          );
        })}
      </div>
      <button type="button" className="btn">
        more info
      </button>
    </section>
  );
};

export default Tab;
